module.exports = __webpack_public_path__ + "static/media/content-for-you-preview.4a369e44.png";